import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import Navbar from "@/components/Navbar";
import { toast } from "sonner";

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        setLoading(true);
        try {
            await login(email, password);
            toast.success("Welcome back");
            const to = location.state?.from?.pathname || "/workspace";
            navigate(to, { replace: true });
        } catch (e2) {
            setErr(formatApiError(e2));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen">
            <Navbar />
            <div className="max-w-md mx-auto px-6 py-16">
                <div className="lk-label">Welcome back</div>
                <h1 className="font-heading text-4xl mt-2 tracking-tight">Log in to Lakshmi</h1>
                <p className="text-[var(--lk-muted)] mt-3 text-sm">Pick up where you left off. Your voice, your history, your workflow.</p>

                <form onSubmit={submit} className="mt-8 space-y-4">
                    <div>
                        <label className="lk-label block mb-2">Email</label>
                        <input
                            type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                            className="w-full lk-border lk-surface-2 rounded-lg px-4 py-3 focus:outline-none focus:border-[var(--lk-primary)]"
                            data-testid="login-email-input"
                            placeholder="you@company.com"
                        />
                    </div>
                    <div>
                        <label className="lk-label block mb-2">Password</label>
                        <input
                            type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                            className="w-full lk-border lk-surface-2 rounded-lg px-4 py-3 focus:outline-none focus:border-[var(--lk-primary)]"
                            data-testid="login-password-input"
                            placeholder="••••••••"
                        />
                    </div>
                    {err ? <div className="text-sm text-red-400" data-testid="login-error">{err}</div> : null}
                    <button
                        type="submit" disabled={loading}
                        className="lk-btn-primary rounded-full px-6 py-3 w-full disabled:opacity-50"
                        data-testid="login-submit-btn"
                    >
                        {loading ? "Signing in..." : "Log in"}
                    </button>
                </form>

                <div className="mt-6 text-sm text-[var(--lk-muted)]">
                    No account yet? <Link to="/signup" className="text-[var(--lk-primary)] underline" data-testid="login-to-signup">Create one</Link>
                </div>
            </div>
        </div>
    );
}
